module.exports = __webpack_public_path__ + "img/difficulty-3-stars.42d510eb.png";